import _plugin_vue_export_helper_default from "../../../../_virtual/_plugin-vue_export-helper.js";
import ResponseBody_vue_vue_type_script_setup_true_lang_default from "./ResponseBody.vue.script.js";
/* empty css                           */
//#region src/v2/blocks/response-block/components/ResponseBody.vue
var ResponseBody_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ResponseBody_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-bb31ac6f"]]);
//#endregion
export { ResponseBody_default as default };

//# sourceMappingURL=ResponseBody.vue.js.map